import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { loaderItems } from "../../../../../../../../../shared/src/lib/utils/common";

@Component({
  selector: "app-today-tomorrow-loader",
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./today-tomorrow-loader.component.html",
  styleUrl: "./today-tomorrow-loader.component.scss",
})
export class TodayTomorrowLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly loaderItems = loaderItems;
}
